import { normalizeColumnName } from '../../common/utils/normalizeColumnName';

export function getRowValueByColumnName(
  row: Record<string, unknown>,
  columnName: string
): unknown {
  const normalizedTarget = normalizeColumnName(columnName);

  for (const key of Object.keys(row)) {
    if (normalizeColumnName(key) === normalizedTarget) {
      return row[key];
    }
  }

  return row[columnName];
}

